import script from "./StatusMark.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusMark.vue?vue&type=script&setup=true&lang=js"

import "./StatusMark.vue?vue&type=style&index=0&id=1c2744b2&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c2744b2"]])

export default __exports__